import { ApiResult, request, safeRequest } from '@synergy/api';

import { ContactPermissions } from '../models/contact-permissions';
import { EmailErrorCode } from '../../../../models/email-error-code';
import { EmailErrorHandler } from '../../../../api/email-error-handler';
import { InviteContactRequest } from './models/invite-contact-request';
import { PatchPermissionsRequest } from './models/patch-permissions-request';

export class ContactPermissionsApi {
    constructor(protected baseUrl: string) {}

    public get(contactId: number): Promise<ApiResult<ContactPermissions>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/contacts/${contactId}/permissions`),
            response => response.data
        );
    }

    public updatePermissions(
        contactId: number,
        permissions: PatchPermissionsRequest
    ): Promise<ApiResult<ContactPermissions, EmailErrorCode>> {
        return safeRequest(
            () => request.patch(`${this.baseUrl}/contacts/${contactId}/permissions`, permissions),
            response => response.data,
            EmailErrorHandler
        );
    }

    public deleteUser(contactId: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.delete(`${this.baseUrl}/contacts/${contactId}/delete-user`),
            () => null
        );
    }

    public inviteContact(contactId: number, permissions: InviteContactRequest): Promise<ApiResult<ContactPermissions>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/contacts/${contactId}/invite`, permissions),
            response => response.data
        );
    }
}
